import {
  setCheckButtons,
  setTableButtons,
  setFormButtons,
  getStepFormBottomButtons
} from '@/utils/getbuttons.js'
import { daysFormat } from '@/filters'
import enterprise from '@/utils/pageParams/enterprise'
import person from '@/utils/pageParams/person.js'
import bidSection from '@/utils/pageParams/bidSection.js'
import { withSelectedOption } from '@/utils/handleData.js'
import esign from '@/utils/pageParams/esign.js'

const personUser = {
  title: '新增个人档案',
  addFun: 'user/addPersonUser',
  detailPage: [
    {
      buttonName: '弹窗提交',
      type: 'cardForm',
      name: 'person',
      step: 'personInfo',
      theme: 'contractor',
      label: '完善个人档案',
      pageStatus: 'adminAdd'
    }
  ],
  formParams: {
    telphoneNum: '',
    personName: ''
  },
  formRules: {
    telphoneNum: [
      {
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
      },
      {
        pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
        message: '手机号码输入不合法',
        trigger: 'blur'
      }
    ],
    personName: [
      {
        validator: (params) => {
          return params.validate.validatePersonName
        },
        trigger: 'blur'
      }
    ]
  },
  formData: [
    {
      key: 'telphoneNum',
      label: '手机号码',
      type: 'input',
      placeholder: '请输入手机号码按回车键验证用户是否已存在',
      span: 18
    },
    {
      key: 'personName',
      label: '人员姓名',
      type: 'input',
      placeholder: '系统自动查询用户关联人员',
      disabled: true,
      span: 18
    },
    {
      type: 'tag',
      isShow: (params) => {
        return params.formError.tag
      },
      tag: (params) => {
        return params.formError.tag ? params.formError.tag : null
      },
      span: 18
    }
  ]
}

const leaderArchivePages = [
  {
    buttonName: '去添加人员',
    type: 'cardForm',
    name: 'person',
    theme: 'contractor',
    step: 'personInfo',
    label: '新增人员档案',
    pageStatus: 'adminAdd'
  },
  {
    buttonName: '查看个人档案',
    type: 'cardForm',
    name: 'person',
    label: '查看个人档案',
    theme: 'contractor',
    step: 'personInfo',
    checkType: 'checkByUid',
    checkUid: (params) => {
      return params.formValues ? params.formValues.leaderUid : ''
    },
    checkFun: 'person/getPersonInfo',
    pageStatus: 'complete'
  }
]

const leaderSelectField = (params, addStep) => {
  const isCheck = params.pageStatus === 'check'
  const canEdit =
    params.pageStatus === 'add' || params.pageStatus === 'edit'
  return {
    key:
      isCheck
        ? 'leaderName'
        : params.pageStatus !== 'exit'
        ? 'leaderUid'
        : null,
    label: '现场负责人',
    type: isCheck ? 'input' : 'select',
    placeholder:
      params.pageStatus === 'edit'
        ? '请从已有人员与已进场人员中搜索选择'
        : '请输入姓名或身份证号在人员库中搜索，未搜索到请先去添加人员',
    filterable: true,
    remote: !isCheck && params.pageStatus !== 'edit',
    optionImg: true,
    optionPerson: true,
    checkByValue: true,
    disabled: isCheck,
    echoLabelKey: 'leaderName',
    options: (p) => {
      const selected =
        (p.state.contractor && p.state.contractor.leaderSelectOptions) || []
      const library = (p.state.person && p.state.person.personNames) || []
      const base =
        params.pageStatus === 'edit' || params.pageStatus === 'check'
          ? selected.length
            ? selected
            : library
          : library
      return withSelectedOption(
        base,
        p.formValues && p.formValues.leaderUid,
        p.formValues && p.formValues.leaderName
      )
    },
    check: (p) => {
      if (params.pageStatus === 'exit') {
        return ''
      }
      return p.formValues && p.formValues.leaderUid
        ? '查看个人档案'
        : canEdit
        ? '去添加人员'
        : '查看个人档案'
    },
    step: params.pageStatus === 'add' ? addStep : 0
  }
}

const leaderSearchTag = (params, addStep) => ({
  type: null,
  step: params.pageStatus === 'add' ? addStep : 0
})

const contractor = {
  pageTabs: [
    {
      label: '劳务公司',
      theme: 'contractor',
      step: 'laborCompanyList',
      stepLabel: '劳务公司列表',
      checkFun: 'contractor/getLaborCompanyList'
    },
    {
      label: '管理单位',
      theme: 'contractor',
      step: 'manageCompanyList',
      stepLabel: '管理单位列表',
      checkFun: 'contractor/getManageCompanyList'
    }
  ],
  laborCompany: {
    name: 'laborCompany',
    theme: '劳务公司',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'stepForm',
      'entForm',
      'dialogForm',
      'dialogTable'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'contractor/getLaborCompanyList',
    deleteFun: 'contractor/deleteLaborCompany',
    deleteConfirm: (params) => {
      if (params.userName === 'dpnadmin') {
        return '将删除该劳务公司在所在项目的全部业务数据，且不可恢复。是否继续？'
      }
      return '此操作将永久删除该条数据, 是否继续?'
    },
    getDetailFun: 'contractor/getLaborCompanyInfo',
    addFun: 'contractor/addLaborCompany',
    editFun: 'contractor/editLaborCompany',
    exitFun: 'contractor/exitLaborCompany',
    detailPage: [
      {
        buttonName: '进场',
        type: 'stepForm',
        name: 'laborCompany',
        step: 'laborCompanyInfo',
        theme: 'contractor',
        label: '劳务公司进场登记'
      },
      {
        buttonNames: ['编辑', '退场', '查看'],
        type: 'stepForm',
        name: 'laborCompany',
        checkType: 'checkByUid',
        checkFun: 'contractor/getLaborCompanyInfo',
        step: 'laborCompanyInfo',
        theme: 'contractor',
        label: () => {
          return (params) => {
            if (params.code === 'edit') {
              return '编辑劳务公司信息'
            } else if (params.code === 'check') {
              return '查看劳务公司信息'
            } else if (params.code === 'exit') {
              return '劳务公司退场登记'
            }
          }
        }
      },
      {
        buttonName: '去添加企业',
        type: 'cardForm',
        name: 'enterprise',
        label: '添加企业档案',
        theme: 'contractor',
        step: 'enterpriseInfo',
        pageStatus: 'add'
      },
      {
        buttonName: '查看企业档案',
        type: 'cardForm',
        name: 'enterprise',
        label: '查看企业档案',
        theme: 'contractor',
        step: 'enterpriseInfo',
        checkType: 'checkByUid',
        checkUid: (params) => {
          return params.formValues ? params.formValues.companyUid : ''
        },
        checkFun: 'enterprise/getEnterpriseInfo',
        pageStatus: 'complete'
      },
      ...leaderArchivePages,
      {
        buttonName: '查看未退场人员',
        type: 'dialogTable',
        name: 'noExitPerson',
        checkType: 'checkByUid',
        checkUid: (params) => {
          return params.currentUids
        },
        checkFun: 'contractor/getNoExitName'
      },
      {
        buttonName: '退场承诺书',
        type: 'preview'
      }
    ],
    rowKey: 'vProjectUid',
    headButtons: setCheckButtons(['进场']),
    queryParams: {
      organUid: (params) => {
        return params.orgValue
      },
      upVproUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      isExit: '',
      queryComLea: ''
    },
    selectData: [
      {
        key: 'upVproUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'isExit',
        label: '在场状态',
        type: 'select',
        options: (params) => {
          return params.dictionarys.isExit
        }
      },
      {
        key: 'queryComLea',
        label: '关键词',
        type: 'input',
        placeholder: '劳务公司名称/现场负责人'
      }
    ],
    rowData: (params) => {
      return params.state.contractor.laborCompanyList.result
    },
    rowTotal: (params) => {
      return params.state.contractor.laborCompanyList.totalSize
    },
    columns: (params) => {
      const columns = [
        { prop: 'companyName', label: '劳务公司名称', minWidth: '220px', overflow: false, overflowWidth: true, tooltip: { tipKey: 'formerName', tipLabel: '曾用名：' } }
      ]
      if (params.orgType !== 'simPro') {
        columns.push({
          prop: 'projectCode',
          label: '项目标段',
          width: '200px'
        })
      }
      columns.push(
        { prop: 'personName', label: '现场负责人', minWidth: '100px', overflow: false, tooltip: { tipKey: 'personFormerName', tipLabel: '曾用名：' } },
        { prop: 'phoneNumber', label: '现场负责人电话', width: '' },
        {
          prop: 'noteInfo',
          label: '在场状态',
          tag: (params) => {
            return params.dictionarys.isExit
          }
        },
        { prop: 'walkinDate', label: '进场时间', minWidth: '120px' },
        { prop: 'walkoffDate', label: '退场时间', minWidth: '120px' }
      )
      const showCommitment =
        !(params.state.builder && params.state.builder.showExitCommitmentCol === false)
      if (showCommitment) {
        columns.push({
          prop: 'isPic',
          label: '退场承诺书',
          width: '160px',
          signedDoc: {
            reportCode: 'laborCompanyOut',
            previewLabel: '预览承诺书',
            imageLabel: '承诺书图片',
            lockedLabel: '暂未退场',
            lockWhen: 'notExit',
            saveFun: 'contractor/uploadLaborCompanyoutpic',
            refreshFun: 'contractor/getLaborCompanyList',
            laborTeamUidKey: 'uid',
            electronicSign: true,
            multi: false,
            limit: 6
          }
        })
      }
      columns.push({
        label: '操作',
        buttons: setTableButtons(['查看', '编辑', '删除', '退场', '二维码']),
        width: '360px'
      })
      return columns
    },
    hasPagination: true,
    formParams: {
      uid: '',
      companyUid: '',
      name: '',
      projectUid: (params) => {
        return params.orgValue
      },
      projectName: (params) => {
        return params.orgName
      },
      walkinDate: daysFormat(new Date()),
      leaderUid: '',
      leaderName: '',
      leaderPhone: '',
      leaderSignatureUid: '',
      workContent: '',
      noExitCount: 0,
      walkoffDate: '',
      walkoffCause: '',
      picUid: '',
      cumulativeShouldPay: 0,
      cumulativeActualPay: 0,
      cumulativeOwePay: 0,
      payRate: 0,
      skipSalaryExitFlow: false,
      skipExitCommitStep: false,
      fileLists: {
        picUid: [],
        leaderSignatureUid: []
      }
    },
    formRules: (params) => {
      var formRules = {}
      formRules = {
        companyUid: [
          {
            required: params.pageStatus === 'add',
            message: '请选择要进场的劳务公司名称',
            trigger: 'blur'
          }
        ],
        walkinDate: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请选择进场时间',
            trigger: 'blur'
          }
        ],
        leaderUid: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请搜索选择现场负责人',
            trigger: 'change'
          }
        ],
        leaderPhone: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请输入现场负责人电话',
            trigger: 'blur'
          },
          {
            pattern:
              params.pageStatus === 'add' ? /^1(3|4|5|6|7|8|9)\d{9}$/ : null,
            message: '手机号码输入不合法',
            trigger: 'blur'
          }
        ],
        workContent: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请输入作业内容简介，30字以内',
            trigger: 'blur'
          }
        ],
        noExitCount: [
          {
            validator: (params) => {
              return params.pageStatus === 'exit'
                ? params.validate.validateNoExitCount
                : null
            },
            trigger: 'blur'
          }
        ],
        walkoffDate: [
          {
            required: params.pageStatus === 'exit',
            message: '请选择退场时间',
            trigger: 'blur'
          }
        ],
        walkoffCause: [
          {
            required: params.pageStatus === 'exit',
            message: '请选择退场原因',
            trigger: 'blur'
          }
        ]
      }
      return formRules
    },
    formData: (params) => {
      const form =
        params.formValues ||
        (params.state.formValues && params.state.formValues.laborCompany) ||
        {}
      const exitGate =
        (params.state.contractor && params.state.contractor.exitSalaryGate) || null
      const gateReady = !!(exitGate && typeof exitGate.skip === 'boolean')
      // gate 未就绪：不渲染步骤/字段（骨架 throttle 间隙也不露出上次内容）
      if (params.pageStatus === 'exit' && !gateReady) {
        return {
          card: null,
          titles: null,
          finishStep: null,
          finishStatus: null,
          finishtip: null,
          tips: null,
          bottomButtons: null,
          fields: []
        }
      }
      const skipSalaryExit =
        params.pageStatus === 'exit' &&
        !!(
          (gateReady ? exitGate.skip : form.skipSalaryExitFlow) ||
          form.skipExitCommitStep
        )
      var formData = {
        card:
          params.pageStatus === 'edit' || params.pageStatus === 'check'
            ? '劳务公司信息'
            : null,
        titles:
          params.pageStatus === 'add'
            ? ['企业信息核查', '进场信息登记', '完成']
            : params.pageStatus === 'exit'
            ? skipSalaryExit
              ? ['企业信息核查', '退场信息登记']
              : ['企业信息核查', '退场信息登记', '退场承诺书']
            : null,
        finishStep:
          params.pageStatus === 'add'
            ? 2
            : params.pageStatus === 'exit' && !skipSalaryExit
            ? 3
            : null,
        finishStatus:
          params.pageStatus === 'add'
            ? '备案成功'
            : params.pageStatus === 'exit' && !skipSalaryExit
            ? '退场成功'
            : null,
        finishtip:
          params.pageStatus === 'add'
            ? '备案完成并生成劳务公司二维码'
            : params.pageStatus === 'exit' && !skipSalaryExit
            ? '退场成功并生成退场承诺书'
            : null,
        tips:
          params.pageStatus === 'add'
            ? [
                {
                  step: 0,
                  text: [
                    '1、参建单位进场前先确认企业信息完善情况符合要进场的项目标段的管理要求。'
                  ]
                },
                {
                  step: 1,
                  text: [
                    '1、现场负责人为劳务分包企业在项目中总负责人，负责劳务公司在项目中合同签订、结算办理及相关报表等签字确认，从人员库按姓名或身份证号搜索选择；',
                    '2、人员库未搜索到时，请先去添加人员后再选择；',
                    '3、中途更换现场负责人时，在劳务公司列表中编辑即可，不要求该人已在本项目进场。'
                  ]
                }
              ]
            : params.pageStatus === 'exit'
            ? skipSalaryExit
              ? [
                  {
                    step: 0,
                    text: [
                      '1、劳务公司退场前，须先确保其在本项目的劳务人员全部退场（未退场人数为 0 才可下一步）；',
                      '2、当前劳务公司未开通薪酬统计模块，企业信息核查不展示累计薪酬，也不生成退场承诺书；',
                      '3、可点击「查看未退场人员」核对仍在场人员，通过「查看企业档案」核对企业信息。'
                    ]
                  },
                  {
                    step: 1,
                    text: [
                      '1、退场日期默认当天，退场原因已预填，均可按实际情况修改；',
                      '2、退场信息登记提交后直接完成退场并返回列表。'
                    ]
                  }
                ]
              : [
                  {
                    step: 0,
                    text: [
                      '1、劳务公司退场前，须先确保其在本项目的劳务人员全部退场（未退场人数为 0 才可下一步）；',
                      '2、退场信息登记提交后，系统按该企业在本项目的累计薪酬统计生成退场承诺书，由现场负责人确认；确认完成后退场手续办结；',
                      '3、可点击「查看未退场人员」核对应退场人员；企业档案可通过「查看企业档案」核对。'
                    ]
                  },
                  {
                    step: 1,
                    text: [
                      '1、退场日期默认当天，退场原因已预填，均可按实际情况修改；',
                      '2、提交后进入退场承诺书预览与确认步骤。'
                    ]
                  }
                ]
            : null,
        bottomButtons:
          params.pageStatus === 'add'
            ? getStepFormBottomButtons(0)
            : params.pageStatus === 'exit'
            ? getStepFormBottomButtons(2)
            : params.pageStatus === 'edit'
            ? setFormButtons(['取消', '提交'])
            : null,
        fields: [
          {
            key: params.pageStatus === 'add' ? 'companyUid' : null,
            label: '劳务公司名称',
            type: 'select',
            step: 0,
            placeholder: '请输入关键词搜索选择',
            filterable: true,
            remote: true,
            options: (params) => {
              return params.state.enterprise.enterprises
            },
            checkByValue: true
          },
          {
            key: params.pageStatus !== 'add' ? 'name' : null,
            label: '劳务公司名称',
            type: 'input',
            step: 0,
            disabled: true,
            check: '查看企业档案'
          },
          {
            type: params.pageStatus === 'add' ? 'tag' : null,
            step: 0,
            tagType: (params) => {
              return params.formValues && params.formValues.companyUid
                ? ''
                : 'danger'
            },
            tagIcon: (params) => {
              return params.formValues && params.formValues.companyUid
                ? 'el-icon-success'
                : 'el-icon-warning'
            },
            tag: (params) => {
              return params.formValues && params.formValues.companyUid
                ? '你已选择要进场的劳务公司，进场前可点击查看其企业档案详情，确认选择无误。'
                : '如果未搜索到要进场的劳务公司，则该企业还未在企业库注册认证，请先点击去添加企业。'
            },
            tagButtons: (params) => {
              return params.formValues && params.formValues.companyUid
                ? ['查看企业档案']
                : ['去添加企业']
            }
          },
          {
            key: params.pageStatus !== 'exit' ? 'projectName' : null,
            label: '所属项目标段',
            type: 'input',
            step: params.pageStatus === 'add' ? 1 : 0,
            disabled: true
          },
          {
            key: params.pageStatus !== 'exit' ? 'walkinDate' : null,
            label: '进场日期',
            type: 'time',
            step: params.pageStatus === 'add' ? 1 : 0
          },
          leaderSelectField(params, 1),
          leaderSearchTag(params, 1),
          {
            key: params.pageStatus !== 'exit' ? 'leaderPhone' : null,
            label: '现场负责人电话',
            type: 'input',
            step: params.pageStatus === 'add' ? 1 : 0
          },
          {
            key:
              params.pageStatus === 'add' ||
              params.pageStatus === 'edit' ||
              params.pageStatus === 'check'
                ? 'leaderSignatureUid'
                : null,
            label: '现场负责人签名',
            type: 'upload',
            fileType: 'signature',
            url: '/static/files/signature',
            listType: 'text',
            showFilelist: false,
            limit: 1,
            uploadtip: '点击上传签名图片（非必填）',
            tip: '非必填，可直接上传签名图片',
            step: params.pageStatus === 'add' ? 1 : 0
          },
          {
            key:
              params.pageStatus === 'exit' && !skipSalaryExit
                ? 'cumulativeShouldPay'
                : null,
            label: '累计应发薪酬',
            type: 'input',
            step: 0,
            disabled: true,
            inputButton: '元'
          },
          {
            key:
              params.pageStatus === 'exit' && !skipSalaryExit
                ? 'cumulativeActualPay'
                : null,
            label: '累计实发薪酬',
            type: 'input',
            step: 0,
            disabled: true,
            inputButton: '元'
          },
          {
            key:
              params.pageStatus === 'exit' && !skipSalaryExit
                ? 'cumulativeOwePay'
                : null,
            label: '累计欠发薪酬',
            type: 'input',
            step: 0,
            disabled: true,
            inputButton: '元'
          },
          {
            key:
              params.pageStatus === 'exit' && !skipSalaryExit ? 'payRate' : null,
            label: '累计发放率',
            step: 0,
            type: 'input',
            disabled: true,
            inputButton: '%'
          },
          {
            key: params.pageStatus === 'exit' ? 'noExitCount' : null,
            label: '未退场人数',
            step: 0,
            type: 'input',
            disabled: true,
            check:
              params.formValues && params.formValues.noExitCount > 0
                ? '查看未退场人员'
                : null
          },
          {
            key:
              params.pageStatus === 'check' || params.pageStatus === 'exit'
                ? 'walkoffDate'
                : null,
            label: '退场日期',
            type: 'time',
            step: params.pageStatus === 'exit' ? 1 : 0
          },
          {
            key:
              params.pageStatus === 'check' || params.pageStatus === 'exit'
                ? 'walkoffCause'
                : null,
            label: '退场原因',
            type: 'select',
            step: params.pageStatus === 'exit' ? 1 : 0,
            options: (params) => {
              return params.dictionarys.walkoffCause
            }
          },
          {
            key: params.pageStatus !== 'exit' ? 'workContent' : null,
            label: '作业内容',
            type: 'input',
            placeholder: '请输入进场作业主要内容，30字以内',
            inputType: 'textarea',
            autosize: { minRows: 2, maxRows: 4 },
            step: params.pageStatus === 'add' ? 1 : 0
          },
          {
            key:
              params.pageStatus === 'check' ||
              (params.pageStatus === 'exit' && !skipSalaryExit)
                ? 'picUid'
                : null,
            label: '退场承诺书',
            type: 'signedReport',
            reportCode: 'laborCompanyOut',
            saveFun: 'contractor/uploadLaborCompanyoutpic',
            laborTeamUidKey: 'uid',
            previewLabel: '预览承诺书',
            imageLabel: '承诺书图片',
            electronicSign: true,
            lockWhen: 'notExit',
            limit: 6,
            step: params.pageStatus === 'exit' ? 2 : 0
          }
        ]
      }
      return formData
    },
    noExitPerson: {
      name: 'noExitPerson',
      title: '未退场人员列表',
      getListFun: 'contractor/getNoExitName',
      headButtons: setCheckButtons(['去办理退场']),
      detailPage: [
        {
          buttonName: '去办理退场',
          type: 'path',
          path: '/workbench/builder'
        }
      ],
      rowData: (params) => {
        return params.state.contractor.noExitName
      },
      columns: [
        {
          label: '姓名',
          prop: 'personName',
          width: '100px'
        },
        {
          label: '手机号码',
          prop: 'phoneNumber'
        },
        {
          label: '当前工种',
          prop: 'business'
        },
        {
          label: '进场时间',
          prop: 'walkinDate'
        }
      ],
      hasFooter: false
    },
    personUser: personUser
  },
  manageCompany: {
    name: 'manageCompany',
    theme: '管理单位',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'stepForm',
      'entForm',
      'dialogForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    rowKey: 'vProjectUid',
    headButtons: setCheckButtons(['进场']),
    getListFun: 'contractor/getManageCompanyList',
    deleteFun: 'contractor/deleteManageCompany',
    deleteConfirm: (params) => {
      if (params.userName === 'dpnadmin') {
        return '将删除该管理单位在所在项目的全部业务数据，且不可恢复。是否继续？'
      }
      return '此操作将永久删除该条数据, 是否继续?'
    },
    getDetailFun: 'contractor/getManageCompanyInfo',
    addFun: 'contractor/addManageCompany',
    editFun: 'contractor/editManageCompany',
    exitFun: 'contractor/exitManageCompany',
    detailPage: [
      {
        buttonName: '进场',
        type: 'stepForm',
        name: 'manageCompany',
        step: 'manageCompanyInfo',
        theme: 'contractor',
        label: '管理单位进场登记'
      },
      {
        buttonNames: ['编辑', '查看'],
        type: 'stepForm',
        name: 'manageCompany',
        checkType: 'checkByUid',
        checkFun: 'contractor/getManageCompanyInfo',
        step: 'manageCompanyInfo',
        theme: 'contractor',
        label: () => {
          return (params) => {
            if (params.code === 'edit') {
              return '编辑管理单位信息'
            } else if (params.code === 'check') {
              return '查看管理单位信息'
            }
          }
        }
      },
      {
        buttonName: '退场',
        type: 'stepForm',
        name: 'manageCompany',
        checkType: 'useRowData',
        step: 'manageCompanyInfo',
        theme: 'contractor',
        label: '管理单位退场登记'
      },
      {
        buttonName: '查看企业档案',
        type: 'cardForm',
        name: 'enterprise',
        label: '查看企业档案',
        theme: 'contractor',
        step: 'enterpriseInfo',
        checkType: 'checkByUid',
        checkUid: (params) => {
          return params.formValues ? params.formValues.companyUid : ''
        },
        checkFun: 'enterprise/getEnterpriseInfo',
        pageStatus: 'complete'
      },
      {
        buttonName: '去完善档案',
        type: 'cardForm',
        name: 'bidSection',
        theme: 'contractor',
        step: 'bidSectionInfo',
        label: '完善项目标段档案',
        checkUid: (params) => {
          return params.formValues ? params.formValues.uid : ''
        },
        pageStatus: 'edit'
      },
      ...leaderArchivePages
    ],
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      upVproUid: (params) => {
        return params.orgType === 'simPro' ? params.orgValue : ''
      },
      buildType: '',
      isExit: '',
      queryComLea: ''
    },
    selectData: [
      {
        key: 'upVproUid',
        label: '所属项目标段',
        type: 'select',
        options: (params) => {
          return params.state.bidSection.subBidSection
        },
        checkByValue: true
      },
      {
        key: 'buildType',
        label: '参建类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.buildType
        }
      },
      {
        key: 'isExit',
        label: '在场状态',
        type: 'select',
        options: (params) => {
          return params.dictionarys.isExit
        }
      },
      {
        key: 'queryComLea',
        label: '关键词',
        type: 'input',
        placeholder: '劳务公司名称/现场负责人'
      }
    ],
    rowData: (params) => {
      return params.state.contractor.manageCompanyList.result
    },
    rowTotal: (params) => {
      return params.state.contractor.manageCompanyList.totalSize
    },
    columns: (params) => {
      const columns = [
        { prop: 'orgName', label: '管理单位名称', width: '260px', overflow: false, tooltip: { tipKey: 'formerName', tipLabel: '曾用名：' } }
      ]
      if (params.orgType !== 'simPro') {
        columns.push({
          prop: 'orgCode',
          label: '项目标段',
          width: '200px'
        })
      }
      columns.push(
        { prop: 'orgType', label: '参建类型', width: '' },
        { prop: 'leaderName', label: '现场负责人', width: '', overflow: false, tooltip: { tipKey: 'personFormerName', tipLabel: '曾用名：' } },
        { prop: 'leaderPhone', label: '现场负责人电话', width: '' },
        {
          prop: 'noteInfo',
          label: '在场状态',
          tag: (params) => {
            return params.dictionarys.isExit
          }
        },
        { prop: 'walkinDate', label: '进场时间', width: '' },
        {
          label: '操作',
          buttons: setTableButtons(['查看', '编辑', '删除', '退场', '二维码']),
          width: '360px'
        }
      )
      return columns
    },
    hasPagination: true,
    formParams: {
      uid: '',
      companyUid: '',
      name: '',
      orgCode: '',
      buildType: '',
      walkinDate: daysFormat(new Date()),
      leaderUid: '',
      leaderName: '',
      leaderPhone: '',
      managerRange: '',
      walkOutDate: '',
      walkoffDate: '',
      walkoffCause: '',
      isExit: ''
    },
    formRules: (params) => {
      var formRules = {
        uid: [
          {
            required: params.pageStatus === 'add',
            message: '请选择要进场的项目标段名称',
            trigger: 'blur'
          }
        ],
        companyUid: [
          {
            required: params.pageStatus === 'add',
            message: '请选择要进场管理单位名称',
            trigger: 'blur'
          }
        ],
        buildType: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请选择要进场管理单位参建类型',
            trigger: 'blur'
          }
        ],
        walkinDate: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请选择进场时间',
            trigger: 'blur'
          }
        ],
        leaderUid: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请搜索选择现场负责人',
            trigger: 'change'
          }
        ],
        leaderPhone: [
          {
            required:
              params.pageStatus === 'add' || params.pageStatus === 'edit',
            message: '请输入现场负责人电话',
            trigger: 'blur'
          },
          {
            pattern:
              params.pageStatus === 'add' ? /^1(3|4|5|6|7|8|9)\d{9}$/ : null,
            message: '手机号码输入不合法',
            trigger: 'blur'
          }
        ],
        walkOutDate: [
          {
            required: params.pageStatus === 'exit',
            message: '请选择退场时间',
            trigger: 'blur'
          }
        ],
        walkoffCause: [
          {
            required: params.pageStatus === 'exit',
            message: '请选择退场原因',
            trigger: 'blur'
          }
        ]
      }
      return formRules
    },
    formData: (params) => {
      var formData = {
        card: params.pageStatus !== 'add' ? '管理单位信息' : null,
        titles:
          params.pageStatus === 'add'
            ? ['企业信息核查', '进场信息登记', '完成']
            : null,
        finishStep: params.pageStatus === 'add' ? 2 : null,
        finishStatus: params.pageStatus === 'add' ? '备案成功' : null,
        finishtip:
          params.pageStatus === 'add' ? '备案完成并生成管理单位二维码' : null,
        tips:
          params.pageStatus === 'add'
            ? [
                {
                  step: 0,
                  text: [
                    '1、参建单位进场前先确认企业信息完善情况符合要进场的项目标段的管理要求；',
                    '2、现场负责人为管理单位在项目中第一责任人，管理单位进场时手动填写。'
                  ]
                }
              ]
            : null,
        bottomButtons:
          params.pageStatus === 'add'
            ? getStepFormBottomButtons(1)
            : params.pageStatus !== 'check'
            ? setFormButtons(['取消', '提交'])
            : null,
        fields: [
          {
            key: params.pageStatus === 'add' ? 'uid' : null,
            label: '项目标段名称',
            type: 'select',
            step: 0,
            options: (params) => {
              return params.getters['bidSection/notEnteredBid']
            },
            checkByValue: true
          },
          {
            key: params.pageStatus === 'add' ? 'companyUid' : null,
            label: '管理单位名称',
            type: 'select',
            step: 0,
            options: (params) => {
              return params.state.bidSection.manageCompanyNames
            },
            checkByValue: true,
            check: (p) => {
              if (params.pageStatus !== 'add') {
                return ''
              }
              if (p.formValues && p.formValues.companyUid) {
                return '查看企业档案'
              }
              return p.formValues && p.formValues.uid ? '去完善档案' : ''
            }
          },
          {
            key: params.pageStatus !== 'add' ? 'name' : null,
            label: '管理单位名称',
            type: 'input',
            disabled: true,
            check: '查看企业档案'
          },
          {
            key: params.pageStatus !== 'add' ? 'orgCode' : null,
            label: '所属项目标段',
            type: 'input',
            disabled: true
          },
          {
            type: params.pageStatus === 'add' ? 'tag' : null,
            step: 0,
            tagType: (params) => {
              return params.formValues && params.formValues.companyUid
                ? ''
                : 'danger'
            },
            tagIcon: (params) => {
              return params.formValues && params.formValues.companyUid
                ? 'el-icon-success'
                : 'el-icon-warning'
            },
            tag: (params) => {
              return params.formValues && params.formValues.companyUid
                ? '你已选择要进场的管理单位，进场前可点击查看其企业档案详情，确认选择无误。'
                : '管理单位仅可在项目标段所属企业或承包单位中选择，如无选项则请先去修改完善项目标段信息。'
            },
            tagButtons: (params) => {
              return params.formValues && params.formValues.companyUid
                ? ['查看企业档案']
                : []
            }
          },
          {
            key: params.pageStatus !== 'exit' ? 'buildType' : null,
            label: '参建类型',
            type: 'select',
            step: params.pageStatus === 'add' ? 1 : 0,
            options: (params) => {
              return params.dictionarys.buildType
            }
          },
          {
            key: 'walkinDate',
            label: '进场日期',
            type: 'time',
            step: params.pageStatus === 'add' ? 1 : 0,
            disabled: params.pageStatus === 'exit'
          },
          leaderSelectField(params, 1),
          leaderSearchTag(params, 1),
          {
            key: params.pageStatus !== 'exit' ? 'leaderPhone' : null,
            label: '现场负责人电话',
            type: 'input',
            disabled: params.pageStatus === 'edit',
            step: params.pageStatus === 'add' ? 1 : 0
          },
          {
            key:
              params.pageStatus === 'check' || params.pageStatus === 'exit'
                ? 'walkOutDate'
                : null,
            label: '退场日期',
            type: 'time'
          },
          {
            key:
              params.pageStatus === 'check' || params.pageStatus === 'exit'
                ? 'walkoffCause'
                : null,
            label: '退场原因',
            type: 'select',
            options: params.dictionarys.walkoffCause
          },
          {
            key: params.pageStatus !== 'exit' ? 'managerRange' : null,
            label: '管理职责范围',
            type: 'input',
            step: params.pageStatus === 'add' ? 1 : 0,
            placeholder: '请简述管理职责范围，30字以内',
            inputType: 'textarea',
            autosize: { minRows: 3, maxRows: 6 }
          }
        ]
      }
      return formData
    },
    personUser: personUser
  },
  enterprise: enterprise.enterprise,
  person: person.person,
  bidSection: bidSection.bidSection,
  esign
}

export default contractor
